import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { isTokenExpired } from '../../../services/authentication/utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import RegisterFormComponent from '../../authentication/register/RegisterFormComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './RegisterPage.scss';

export class RegisterPage extends React.Component {
    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }

    isMemberAuthenticated = () =>
        this.props.token && !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history }) {
        if (this.isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                history.push(PATH.HOME_PATH);
                resolve();
            });
        }
    }

    render() {
        const { i18nPage, BRAND_NAME_ALT } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-register">
                <HeadComponent
                    title={i18nPage.TITLE}
                    description={i18nPage.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.REGISTER_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.REGISTER_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18nPage.TITLE}</h1>

                <RegisterFormComponent />

                <p className="register-link txtcenter">
                    {convertHtmlToReactDomWithParams(
                        i18nPage.ALREADY_REGISTERED_TEXT,
                        BRAND_NAME_ALT
                    )}
                    &nbsp;
                    <LocalizedNavLink to={PATH.LOGIN_PATH}>{i18nPage.CONNECT_ME}</LocalizedNavLink>
                </p>
            </main>
        );
    }
}

RegisterPage.propTypes = {
    i18nPage: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.REGISTER,
        BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT,
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated
    };
};

export default withTemplate(connect(mapStateToProps, null)(RegisterPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/register/RegisterPage.js